












import { Component, Vue } from 'vue-property-decorator'
import About from '@/views/About.vue'
import { navigation, context, storage } from '@/store/modules'
import SplashScreen from '@/components/SplashScreen.vue'

@Component({
  components: { SplashScreen, About }
})
export default class App extends Vue {
  get aboutOpen () {
    return navigation.aboutOpen
  }

  get loadingContexts (): boolean {
    return context.loadingContexts
  }

  async created () {
    await context.fetchAllContexts()
    context.setActiveContext(null)
    await storage.initEntityTypes()
  }
}
